import { render } from "./ProjectButton.vue?vue&type=template&id=0ee6ec4a&scoped=true&ts=true"
import script from "./ProjectButton.vue?vue&type=script&lang=ts"
export * from "./ProjectButton.vue?vue&type=script&lang=ts"

import "./ProjectButton.vue?vue&type=style&index=0&id=0ee6ec4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ee6ec4a"]])

export default __exports__